import {
  IFileApiService,
  InitAddFileItem,
  InitAddFilesRequestModel,
  AbortFileRequestModel,
  CompleteAddFileRequestModel,
  UploadFileChunkRequestModel,
  UploadFileChunkResponseModel,
} from "tir-pm-file-upload-manager";
import ApiService from "@/shared/api";
import AbortAddFileRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/AbortAddFileRequest";
import CompleteAddFileRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/CompleteAddFileRequest";
import SendFileChunkRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/SendFileChunkRequest";
import StartAddFileBatchRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/StartAddFileBatchRequest";
import StartAddFileBatchRequestItem from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/StartAddFileBatchRequestItem";
import RoomInfoRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/RoomInfoRequest";
import { Events, ResponseModel } from "../models";

export class FileApiService implements IFileApiService {
  private readonly api = new ApiService();
  /**Событие при успешной загрузке файла */
  CompleteEvent = new Events<number>();

  constructor() {
    this.api.File.FileService.OnCompleteAddFileEvent.on((res) => {
      if (res.IsSuccess && res.Value?.FileId) {
        this.CompleteEvent.trigger(res.Value.FileId);
      }
    });
  }

  /**
   * Инициализация добавления файлов
   * @param request
   */
  async initAddFiles(
    request: InitAddFilesRequestModel
  ): Promise<InitAddFileItem[]> {
    const resp = await this.api.File.FileService.startAddFileBatchAsync(
      new StartAddFileBatchRequest({
        FolderId: request.FolderId,
        TaskId: request.TaskId,
        QueueTaskId: request.QueueTaskId,
        ChatId: request.ChatId,
        Files: request.Files.map(
          (file) =>
            new StartAddFileBatchRequestItem({
              FileName: file.FileName,
              FileId: file.FileId,
              FileSize: file.FileSize,
            })
        ),
      })
    );
    return resp.Items.map((item) => ({
      FileId: item.FileId,
      UploadId: item.UploadId,
      Url: item.Url,
      Name: item.Name,
    }));
  }

  /**
   * Загрузка 1 чанка
   * @param request
   */
  async uploadChunk(
    request: UploadFileChunkRequestModel
  ): Promise<UploadFileChunkResponseModel> {
    const resp = await this.api.File.FileService.sendFileChunkAsync(
      new SendFileChunkRequest({
        FileChunk: request.FileChunk,
        FileId: request.FileId,
        UploadId: request.UploadId,
        PartNumber: request.PartNumber,
      })
    );

    return new UploadFileChunkResponseModel({
      ChunkIsSuccess: resp.ChunkIsSuccess,
      UploadId: resp.UploadId,
      FileId: resp.FileId,
    });
  }

  /**
   * Подтверждение окончания загрузки файла
   * @param request
   */
  async completeAddFile(
    request: CompleteAddFileRequestModel
  ): Promise<boolean> {
    const resp = await this.api.File.FileService.completeAddFileAsync(
      new CompleteAddFileRequest({
        UploadId: request.UploadId,
        FileId: request.FileId,
        Room: request.Room
          ? new RoomInfoRequest({
              Name: request.Room.Name,
              Type: request.Room.Type as number,
            })
          : undefined,
      })
    );

    return resp.FileIsSuccess;
  }

  /**
   * Отмена загрузки файла
   * @param data
   */
  async abortUploadFile(data: AbortFileRequestModel): Promise<ResponseModel> {
    return new Promise<ResponseModel>(async (resolve) => {
      const result = new ResponseModel();

      const request = new AbortAddFileRequest({
        UploadId: data.UploadId,
        FileId: data.FileId,
      });

      this.api.File.FileService.abortAddFileAsync(request)
        .then(() => {
          resolve(result);
        })
        .catch((e) => {
          console.error("ERROR abortUploadFile", e);
          result.IsSuccess = false;
          result.ErrorCode = e.ErrorCode;
          result.ErrorMessage = e.ErrorMessage;
          resolve(result);
        });
    });
  }
}
